import React from "react";
import { Label, Input, Button} from 'reactstrap';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import authentication from "../../../utils/authentication";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SimpleReactValidator from 'simple-react-validator';
import validate from "../../../utils/validations"
import { Link, withRouter } from 'react-router-dom';
import profile from '../.././../assets/img/login_page.jpg';
import vertiasLogo from '../.././../assets/img/vertiasLogistic.png';
import toastService from "../../../utils/toastnotification";
import './Login.css';
import { FaArrowLeft } from "react-icons/fa";
import { UncontrolledAlert } from 'reactstrap';
import constant from "../../../constants/constant";
const authenticationService = new authentication();
const toastservice = new toastService();

class ForgotPassword extends React.Component {
    constructor (props) {
        super(props);
        this.validator = new SimpleReactValidator({autoForceUpdate: this});
        this.state = {
            email : "",
          showAlert: false,
          alertType: 'danger',
          alertMessage: ''
          }
          this.handleSubmit = this.handleSubmit.bind(this);
          this.handleInputChange = this.handleInputChange.bind(this)
        }

    handleInputChange(e) {
        let id = e.target.id
        switch (id) {
          case 'email':
            this.setState({ email: e.target.value});
            break;
          default:
            console.log('undefined field');
            break;
        }
      }
      handleSubmit() {
        if (validate.validate(this.validator)) {
          this.forgotPassword()
        }
      }

      forgotPassword () {
        authenticationService.forgotPassword(this.state.email).then((response) => {
          if (response.status === 200) {
            // this.setState({
            //   showAlert: true,
            //   alertType: 'warning',
            //   alertMessage: 'Password sent to mail'
            // });
            toastservice.success(constant.FORGOT_PASSWORD_MESSAGE)
            this.props.history.push('/login');
          } else {
            this.setState({
              showAlert: true,
              alertType: 'danger',
              alertMessage: 'Something went wrong'
            });
          }
        });
      }

    render () {
        const closebtn = <button className="close" onClick={this.props.toggleForgotPasswordModal}>&times;</button>;
        return (
          <div className="container-fluid overflow-hidden bg">
          <div className="row">
            <div className="col-lg-6 p-0 position-relative">
              <div className="position-absolute w-100 h-100 image-overlay"></div>
              <img src={profile} className="login-profile" alt="profile" />
            </div>
            <div className="col-lg-6 d-flex flex-column justify-content-center align-items-center">
              <img src={vertiasLogo} alt="Veritas Logo" />
              <span className="login-content">
              Forgot Password
              </span>
              <div className="mt-3">
                <div className="mb-3">
                  <Label htmlFor="email">Email Id</Label>
                  <Input type="text" id="email" name="email" onChange={this.handleInputChange} className="form-control box-content" placeholder="Email" value={this.state.email}/>
                  {this.validator.message('email', this.state.email, validate.required)}
                </div>
                <div className="mb-3">
                <Button className="login-btn" onClick={(e) => this.handleSubmit(e)}>Reset Password</Button>
                </div>
                <div className="mb-5">
                <Link to="/login" className="link-color"><FaArrowLeft style={{color: "#84155A", marginRight: "5px"}}/>Back to login</Link>
                </div>
                {this.state.showAlert && (
          <UncontrolledAlert color={this.state.alertType}>
            {this.state.alertMessage}
          </UncontrolledAlert>
        )}
              </div>
            </div>
          </div>
        </div>
        )
    }
  }

  export default ForgotPassword

  